
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {
  Code,
  ComponentDocs,
  md,
  Preview,
} from "@lighting-beetle/lighter-styleguide";
import Bar, { BarItem } from "./index";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Bar`}</h1>
    <p>{`Bar is component to create horizontal flexible width layouts.`}</p>
    <h2>{`Example`}</h2>
    <Preview code={<Bar mdxType="Bar">
      <BarItem mdxType="BarItem" />
      <BarItem isFilling mdxType="BarItem" />
      <BarItem mdxType="BarItem" />
    </Bar>} mdxType="Preview">
  <Bar mdxType="Bar">
    <BarItem mdxType="BarItem">
      <div className="l-debug">Item</div>
    </BarItem>
    <BarItem isFilling mdxType="BarItem">
      <div className="l-debug">Filling Item</div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Item</div>
    </BarItem>
  </Bar>
    </Preview>
    <h2>{`Variants`}</h2>
    <h3>{`Basic`}</h3>
    <Preview code={<Bar mdxType="Bar">
      <BarItem mdxType="BarItem" />
      <BarItem mdxType="BarItem" />
      <BarItem mdxType="BarItem" />
    </Bar>} mdxType="Preview">
  <Bar mdxType="Bar">
    <BarItem mdxType="BarItem">
      <div className="l-debug">Item</div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Second item</div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Third item</div>
    </BarItem>
  </Bar>
    </Preview>
    <h3>{`Spaceing`}</h3>
    <Preview code={[<Bar space="small" key="default" mdxType="Bar">
      <BarItem mdxType="BarItem" />
      <BarItem isFilling mdxType="BarItem" />
      <BarItem mdxType="BarItem" />
    </Bar>, <Bar space="small" key="small" mdxType="Bar">
      <BarItem mdxType="BarItem" />
      <BarItem isFilling mdxType="BarItem" />
      <BarItem mdxType="BarItem" />
    </Bar>]} mdxType="Preview">
  <Bar mdxType="Bar">
    <BarItem mdxType="BarItem">
      <div className="l-debug">Default</div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Second item</div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Third item</div>
    </BarItem>
  </Bar>
  <Bar space="small" mdxType="Bar">
    <BarItem mdxType="BarItem">
      <div className="l-debug">Small</div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Second item</div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Third item</div>
    </BarItem>
  </Bar>
    </Preview>
    <h3>{`Alignment`}</h3>
    <Preview title="" code={[<Bar align="top" mdxType="Bar" />, <Bar align="middle" mdxType="Bar" />, <Bar align="bottom" mdxType="Bar" />]} mdxType="Preview">
  <Bar align="top" mdxType="Bar">
    <BarItem mdxType="BarItem">
      <div className="l-debug">Top</div>
    </BarItem>
    <BarItem isFilling mdxType="BarItem">
      <div className="l-debug">
        <p>
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eaque, ipsum
          deleniti quia iure similique mollitia quam excepturi laudantium
          architecto, aperiam magnam exercitationem magni commodi laborum
          molestiae dolore. Corrupti, officia perferendis?
        </p>
      </div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Item</div>
    </BarItem>
  </Bar>
  <Bar align="middle" mdxType="Bar">
    <BarItem mdxType="BarItem">
      <div className="l-debug">Middle</div>
    </BarItem>
    <BarItem isFilling mdxType="BarItem">
      <div className="l-debug">
        <p>
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eaque, ipsum
          deleniti quia iure similique mollitia quam excepturi laudantium
          architecto, aperiam magnam exercitationem magni commodi laborum
          molestiae dolore. Corrupti, officia perferendis?
        </p>
      </div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Item</div>
    </BarItem>
  </Bar>
  <Bar align="bottom" mdxType="Bar">
    <BarItem mdxType="BarItem">
      <div className="l-debug">Bottom</div>
    </BarItem>
    <BarItem isFilling mdxType="BarItem">
      <div className="l-debug">
        <p>
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eaque, ipsum
          deleniti quia iure similique mollitia quam excepturi laudantium
          architecto, aperiam magnam exercitationem magni commodi laborum
          molestiae dolore. Corrupti, officia perferendis?
        </p>
      </div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Item</div>
    </BarItem>
  </Bar>
    </Preview>
    <h3>{`Vertical bar`}</h3>
    <Preview code={<Bar direction="vertical" mdxType="Bar">
      <BarItem mdxType="BarItem" />
      <BarItem isFilling mdxType="BarItem" />
      <BarItem mdxType="BarItem" />
    </Bar>} mdxType="Preview">
  <Bar direction="vertical" mdxType="Bar">
    <BarItem mdxType="BarItem">
      <div className="l-debug">Item</div>
    </BarItem>
    <BarItem isFilling mdxType="BarItem">
      <div className="l-debug">
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi,
          incidunt veniam minima quasi eligendi amet ullam explicabo laborum
          aperiam accusantium hic laboriosam doloremque expedita odit ex
          consequatur voluptas aliquid soluta.
        </p>
      </div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Item</div>
    </BarItem>
  </Bar>
    </Preview>
    <h3>{`Responsive bar (vertical/horizontal)`}</h3>
    <Preview code={<Bar direction={{
      l: "horizontal"
    }} mdxType="Bar">
      <BarItem mdxType="BarItem" />
      <BarItem isFilling mdxType="BarItem" />
      <BarItem mdxType="BarItem" />
    </Bar>} mdxType="Preview">
  <Bar direction={{
        xs: "vertical",
        l: "horizontal"
      }} mdxType="Bar">
    <BarItem mdxType="BarItem">
      <div className="l-debug">Item</div>
    </BarItem>
    <BarItem isFilling mdxType="BarItem">
      <div className="l-debug">
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Temporibus
          soluta voluptatum magni, consequuntur quia odio ad est dicta
          consequatur, nobis modi omnis qui quam magnam ab quo, similique quae
          itaque.
        </p>
      </div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Item</div>
    </BarItem>
  </Bar>
    </Preview>
    <h3>{`Item filling space`}</h3>
    <Preview code={<Bar mdxType="Bar">
      <BarItem mdxType="BarItem" />
      <BarItem mdxType="BarItem" />
      <BarItem mdxType="BarItem" />
    </Bar>} mdxType="Preview">
  <Bar mdxType="Bar">
    <BarItem mdxType="BarItem">
      <div className="l-debug">Item</div>
    </BarItem>
    <BarItem isFilling mdxType="BarItem">
      <div className="l-debug">Second filling item</div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Third item</div>
    </BarItem>
  </Bar>
    </Preview>
    <h3>{`Item which can shrink`}</h3>
    <Preview code={<Bar mdxType="Bar">
      <BarItem mdxType="BarItem" />
      <BarItem mdxType="BarItem" />
      <BarItem mdxType="BarItem" />
    </Bar>} mdxType="Preview">
  <Bar mdxType="Bar">
    <BarItem mdxType="BarItem">
      <div className="l-debug">Item</div>
    </BarItem>
    <BarItem canShrink mdxType="BarItem">
      <div className="l-debug">
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium
          deleniti dignissimos recusandae nesciunt perferendis cupiditate
          perspiciatis harum odit eaque aspernatur dolorem rerum ratione
          repudiandae qui alias assumenda saepe, atque reiciendis?
        </p>
      </div>
    </BarItem>
    <BarItem mdxType="BarItem">
      <div className="l-debug">Third item</div>
    </BarItem>
  </Bar>
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<Bar />" component={Bar} mdxType="ComponentDocs" />
    <ComponentDocs title="<BarItem />" component={BarItem} mdxType="ComponentDocs" />
    <h2>{`Accessibility`}</h2>
    <p>{`The Bar component is primarily used for layout, and as such, should not have any impact on accessibility.`}</p>
    <p>{`Beware however when you are using it for layouts inside `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Inline_elements"
      }}>{`inline elements`}</a>{` such as form labels. `}<inlineCode parentName="p">{`<Bar />`}</inlineCode>{` and `}<inlineCode parentName="p">{`<BarItem />`}</inlineCode>{` benefit from the tag prop to render any html element you want it to.`}</p>
    <h2>{`Aliases`}</h2>
    <Code inline={false} language="jsx" mdxType="Code">
  {`<BarVertical /> === <Bar direction="vertical" />`}
    </Code>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;